// extracted by mini-css-extract-plugin
export default {"usedStyle":"PlanEquationStyle_usedStyle__03Mtc","totalStyle":"PlanEquationStyle_totalStyle__1Zr85"};